import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'public/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SurveysOpinionTaskService {

  refreshAnswerList = new BehaviorSubject<boolean>(false);
  refreshDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {
  }

  createTask(data: any): any {
    return this.http.post(`${environment.apiUrl}/SurveysOpinionTask/CreateTask`, data);
  }

  getListTasksByAdmin(params: any): any {
    return this.http.get(`${environment.apiUrl}/SurveysOpinionTask/ListTasksByAdmin`, { params });
  }

  getAll(params: any): any {
    return this.http.get(`${environment.apiUrl}/SurveysOpinionTask/ListSurveyTasks`, { params });
  }

  getAvailableActions(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/SurveysOpinionTask/GetAvailableActions?taskId=${taskId}`);
  }

  changeTaskStatus(data: any): any {
    return this.http.post(`${environment.apiUrl}/SurveysOpinionTask/ChangeTaskStatus`, data);
  }

  removeTask(id: number) {
    return this.http.delete(`${environment.apiUrl}/SurveysOpinionTask/RemoveTask?id=${id}`);
  }

  getRelatedTracks(hubCode): any {
    return this.http.get(`${environment.apiUrl}/SurveysOpinionTask/GetRelatedTracks?hubCode=${hubCode}`);
  }

  getRelatedGroups(params: any): any {
    return this.http.get(`${environment.apiUrl}/SurveysOpinionTask/GetRelatedGroups`, { params });
  }

  getRelatedAmbassadros(params: any): any {
    return this.http.get(`${environment.apiUrl}/SurveysOpinionTask/GetRelatedAmbassadros`, { params });
  }

  getTaskDetails(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/SurveysOpinionTask/GetTaskDetails?taskId=${taskId}`);
  }

  getTaskLogs(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/SurveysOpinionTask/GetTaskLogs?taskId=${taskId}`);
  }

  getListTasksByAmbassador(params: any): any {
    return this.http.get(`${environment.apiUrl}/SurveysOpinionTask/ListTasksByAmbassador`, { params });
  }

  getSurveyRequestGeographicScopeLookups(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/SurveysOpinionTask/GetSurveyRequestGeographicScopeLookups?taskId=${taskId}`);
  }

  getSurveyResponses(params: any): any {
    return this.http.get(`${environment.apiUrl}/SurveysOpinionTask/GetSurveyResponses`, { params });
  }

  getSurveyResponsesAdmin(params: any): any {
    return this.http.get(`${environment.apiUrl}/SurveysOpinionTask/GetSurveyResponsesAdmin`, { params });
  }

  addResponse(data: any): any {
    return this.http.post(`${environment.apiUrl}/SurveysOpinionTask/AddResponse`, data);
  }
  getSurveyQuestions(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/SurveysOpinionTask/GetSurveyQuestions?taskId=${taskId}`);
  }

  getSurveyResponseDetails(responseId: any): any {
    return this.http.get(`${environment.apiUrl}/SurveysOpinionTask/GetSurveyResponseDetails?responseId=${responseId}`);
  }

  deleteResponse(responseId: any): any {
    return this.http.delete(`${environment.apiUrl}/SurveysOpinionTask/DeleteResponse?responseId=${responseId}`);
  }

  // Comments
  getAllTaskComments(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/SurveysOpinionTask/GetAllTaskComments?taskId=${taskId}`);
  }

  addTaskComment(data: any): any {
    return this.http.post(`${environment.apiUrl}/SurveysOpinionTask/AddTaskComment`, data);
  }
  updateTaskComment(data: any): any {
    return this.http.put(`${environment.apiUrl}/SurveysOpinionTask/UpdateTaskComment`, data);
  }
  deleteTaskComment(commentId: any): any {
    return this.http.delete(`${environment.apiUrl}/SurveysOpinionTask/DeleteTaskComment?commentId=${commentId}`);
  }

  changeResponseStatus(data: any): any {
    return this.http.post(`${environment.apiUrl}/SurveysOpinionTask/ChangeResponseStatus`, data);
  }
}
